<template>
  <div v-if="settings" class="w-full h-full">
    <div
      :class="[
        settings.featured_resources.length > 1
          ? 'h-auto xl:h-10/12'
          : 'h-auto xl:h-screen',
      ]"
      class="w-full relative"
    >
      <div
        :class="
          settings.address_line1 ||
          settings.contact_email ||
          settings.contact_telephone ||
          settings.website
            ? 'info_wrapper '
            : ''
        "
        class="pt-16 flex flex-col h-auto xl:h-full w-full bg-expo_dblue text-white overflow-x-hidden"
      >
        <!-- Info -->
        <div
          v-if="
            settings.regions.length > 0 ||
            settings.contact_email ||
            settings.contact_telephone ||
            settings.website
          "
          class="py-4 w-full px-12 space-y-2"
        >
          <div
            v-if="settings.regions.length > 0"
            class="flex items-start text-white"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-5 w-5 mr-5 flex-shrink-0"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path
                fill-rule="evenodd"
                d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z"
                clip-rule="evenodd"
              />
            </svg>
            <div class="flex flex-wrap w-full">
              <span
                v-for="(region, i) in settings.regions"
                :key="i"
                class="pr-1"
              >
                <span>{{ region.title }}</span>
                <span
                  v-if="
                    settings.regions.length > 1 &&
                    i !== settings.regions.length - 1
                  "
                  >,</span
                >
              </span>
            </div>
          </div>

          <div
            v-if="settings.contact_email"
            class="flex items-center text-white"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-5 w-5 mr-5"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path
                d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z"
              />
              <path
                d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z"
              />
            </svg>
            <span>{{ settings.contact_email }}</span>
          </div>
          <div
            v-if="settings.contact_telephone"
            class="flex items-center text-white"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-5 w-5 mr-5"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path
                d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z"
              />
            </svg>
            <span>{{ settings.contact_telephone }}</span>
          </div>
          <a
            v-if="settings.website_str"
            :href="settings.website"
            class="flex items-center text-white cursor-pointer no-underline"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-5 w-5 mr-5"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path
                fill-rule="evenodd"
                d="M4.083 9h1.946c.089-1.546.383-2.97.837-4.118A6.004 6.004 0 004.083 9zM10 2a8 8 0 100 16 8 8 0 000-16zm0 2c-.076 0-.232.032-.465.262-.238.234-.497.623-.737 1.182-.389.907-.673 2.142-.766 3.556h3.936c-.093-1.414-.377-2.649-.766-3.556-.24-.56-.5-.948-.737-1.182C10.232 4.032 10.076 4 10 4zm3.971 5c-.089-1.546-.383-2.97-.837-4.118A6.004 6.004 0 0115.917 9h-1.946zm-2.003 2H8.032c.093 1.414.377 2.649.766 3.556.24.56.5.948.737 1.182.233.23.389.262.465.262.076 0 .232-.032.465-.262.238-.234.498-.623.737-1.182.389-.907.673-2.142.766-3.556zm1.166 4.118c.454-1.147.748-2.572.837-4.118h1.946a6.004 6.004 0 01-2.783 4.118zm-6.268 0C6.412 13.97 6.118 12.546 6.03 11H4.083a6.004 6.004 0 002.783 4.118z"
                clip-rule="evenodd"
              />
            </svg>
            <span>{{ settings.website_str }}</span>
          </a>
        </div>

        <!-- Socials -->
        <div
          v-if="
            settings.social_fb ||
            settings.social_linked ||
            settings.social_yt ||
            settings.social_twit ||
            settings.social_insta
          "
          class="px-12 flex space-x-4 py-4"
        >
          <a
            v-if="settings.social_fb"
            :href="settings.social_fb"
            target="_blank"
          >
            <svg
              fill="currentColor"
              class="cursor-pointer text-white hover:text-expo_red h-5 w-5 mr-3"
              role="img"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <title>Facebook</title>
              <path
                d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"
              />
            </svg>
          </a>
          <a
            v-if="settings.social_linked"
            :href="settings.social_linked"
            target="_blank"
          >
            <svg
              fill="currentColor"
              class="cursor-pointer text-white hover:text-expo_red h-5 w-5 mr-3"
              role="img"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <title>LinkedIn</title>
              <path
                d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"
              />
            </svg>
          </a>
          <a
            v-if="settings.social_yt"
            :href="settings.social_yt"
            target="_blank"
          >
            <svg
              fill="currentColor"
              class="cursor-pointer text-white hover:text-expo_red h-5 w-5 mr-3"
              role="img"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <title>Youtube</title>
              <path
                d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"
              />
            </svg>
          </a>
          <a
            v-if="settings.social_twit"
            :href="settings.social_twit"
            target="_blank"
          >
            <svg
              fill="currentColor"
              class="cursor-pointer text-white hover:text-expo_red h-5 w-5 mr-3"
              role="img"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <title>Twitter</title>
              <path
                d="M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.209c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.935 9.935 0 0024 4.59z"
              />
            </svg>
          </a>
          <a
            v-if="settings.social_insta"
            :href="settings.social_insta"
            target="_blank"
          >
            <svg
              fill="currentColor"
              class="cursor-pointer text-white hover:text-expo_red h-5 w-5 mr-3"
              role="img"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <title>Instagram</title>
              <path
                d="M12 0C8.74 0 8.333.015 7.053.072 5.775.132 4.905.333 4.14.63c-.789.306-1.459.717-2.126 1.384S.935 3.35.63 4.14C.333 4.905.131 5.775.072 7.053.012 8.333 0 8.74 0 12s.015 3.667.072 4.947c.06 1.277.261 2.148.558 2.913.306.788.717 1.459 1.384 2.126.667.666 1.336 1.079 2.126 1.384.766.296 1.636.499 2.913.558C8.333 23.988 8.74 24 12 24s3.667-.015 4.947-.072c1.277-.06 2.148-.262 2.913-.558.788-.306 1.459-.718 2.126-1.384.666-.667 1.079-1.335 1.384-2.126.296-.765.499-1.636.558-2.913.06-1.28.072-1.687.072-4.947s-.015-3.667-.072-4.947c-.06-1.277-.262-2.149-.558-2.913-.306-.789-.718-1.459-1.384-2.126C21.319 1.347 20.651.935 19.86.63c-.765-.297-1.636-.499-2.913-.558C15.667.012 15.26 0 12 0zm0 2.16c3.203 0 3.585.016 4.85.071 1.17.055 1.805.249 2.227.415.562.217.96.477 1.382.896.419.42.679.819.896 1.381.164.422.36 1.057.413 2.227.057 1.266.07 1.646.07 4.85s-.015 3.585-.074 4.85c-.061 1.17-.256 1.805-.421 2.227-.224.562-.479.96-.899 1.382-.419.419-.824.679-1.38.896-.42.164-1.065.36-2.235.413-1.274.057-1.649.07-4.859.07-3.211 0-3.586-.015-4.859-.074-1.171-.061-1.816-.256-2.236-.421-.569-.224-.96-.479-1.379-.899-.421-.419-.69-.824-.9-1.38-.165-.42-.359-1.065-.42-2.235-.045-1.26-.061-1.649-.061-4.844 0-3.196.016-3.586.061-4.861.061-1.17.255-1.814.42-2.234.21-.57.479-.96.9-1.381.419-.419.81-.689 1.379-.898.42-.166 1.051-.361 2.221-.421 1.275-.045 1.65-.06 4.859-.06l.045.03zm0 3.678c-3.405 0-6.162 2.76-6.162 6.162 0 3.405 2.76 6.162 6.162 6.162 3.405 0 6.162-2.76 6.162-6.162 0-3.405-2.76-6.162-6.162-6.162zM12 16c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4zm7.846-10.405c0 .795-.646 1.44-1.44 1.44-.795 0-1.44-.646-1.44-1.44 0-.794.646-1.439 1.44-1.439.793-.001 1.44.645 1.44 1.439z"
              />
            </svg>
          </a>
        </div>

        <!-- Expos Attending -->
        <div
          v-if="settings.events_attending"
          class="expos-attending relative px-12 pt-4 text-right w-full"
        >
          <div class="flex justify-end items-center mb-2">
            <img
              class="h-5 mr-4 opacity-70"
              src="/img/expo_symbol_white.png"
              alt="Careers Expo logo"
            />
            <h5 class="font-expo_primary font-semibold">EXPOS ATTENDING</h5>
          </div>
          <div class="flex space-x-4 justify-end flex-wrap items-end">
            <a
              v-for="(event, i) in settings.events_attending"
              :key="i"
              :href="settings.central_domain2_url + '/event/' + event.slug"
              class="no-underline expo-title relative text-xs"
            >
              {{ event.title }}
            </a>
          </div>
        </div>

        <!-- Let's Chat CTA -->
        <div
          v-if="settings.enabled_contact && settings.contact_email"
          class="z-50 flex items-end justify-end mt-4 px-12"
        >
          <button class="btn btn-primary uppercase" @click="showContactModal">
            Let's chat
          </button>
        </div>

        <!-- Post image nodes -->
        <div
          v-if="settings.featured_resources.length > 0"
          :class="
            settings.featured_resources.length > 1
              ? 'xl:-bottom-24'
              : 'xl:bottom-0'
          "
          class="post-image-node-container h-80 xl:absolute xl:-left-16 z-40 overflow-x-hidden overflow-y-visible pb-8 xl:p-0"
        >
          <div
            class="post-image-node-wrapper flex justify-center items-end relative transition-all duration-500 ease-in-out"
            :style="{ right: menuPosition }"
          >
            <div
              v-for="(resource, i) in settings.featured_resources"
              :key="i"
              :ref="'featuredPosts-' + i"
              class="bg-cover flex items-center justify-center text-white relative"
              :class="[
                postClass,
                activeResource === i ? activeClass : 'h-48 w-48',
                i < activeResource ? '' : '',
                i > activeResource ? '' : '',
              ]"
              @click="resourceCTA(i)"
            >
              <div
                :style="[
                  resource.type === 2
                    ? { backgroundImage: 'url(' + resource.file + ')' }
                    : {},
                  resource.type === 1
                    ? {
                        backgroundImage: 'url(/img/expo_symbol_white.png)',
                        backgroundColor: '#01172F',
                        backgroundSize: '50px',
                      }
                    : {},
                ]"
                class="absolute bg-center bg-cover inset-0 w-full h-full rounded-4xl overflow-hidden z-10 bg-no-repeat"
                :class="[resource.type === 1 ? 'bg-contain' : 'bg:cover']"
              >
                <div
                  v-if="
                    resource.type === 3 && resource.video_type === 'YouTube'
                  "
                  class="aspect-w-1 aspect-h-1 rounded-4xl"
                >
                  <iframe
                    ref="resourceVideoPreview"
                    type="iframe"
                    class="rounded z-30"
                    :src="youtube + resource.video_code"
                    frameborder="0"
                    controls="0"
                    modestbranding="1"
                    showinfo="0"
                    style="pointer-events: none"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen
                  ></iframe>
                </div>
                <div
                  v-if="resource.type === 3 && resource.video_type === 'Vimeo'"
                  class="rounded-4xl"
                >
                  <iframe
                    ref="resourceVideoPreview"
                    type="iframe"
                    class="rounded z-30 absolute transform right-1/2 bottom-1/2 translate-x-1/2 translate-y-1/2"
                    :src="vimeo + resource.video_code"
                    frameborder="0"
                    controls="0"
                    pip="0"
                    title="1"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen
                    style="height: 350px; width: 622px; pointer-events: none"
                  ></iframe>
                </div>
                <a
                  v-if="resource.type === 1"
                  :id="'fileRef-' + resource.id"
                  :href="resource.file"
                  target="_blank"
                  class="hidden"
                ></a>
              </div>
              <div
                v-if="
                  (resource.type === 3 && resource.video_type === 'Vimeo') ||
                  resource.type === 1
                "
                :class="[
                  activeResource === i ? 'opacity-100' : 'opacity-0',
                  'absolute top-0 z-20 left-0 w-full h-12 text-white rounded-t-4xl overflow-hidden',
                ]"
                class="active-post"
              >
                <h5
                  class="text-center truncate overflow-ellipsis mt-2 relative z-30 font-semibold"
                >
                  {{ resource.title }}
                </h5>
              </div>

              <svg
                v-if="
                  resource.type === 3 &&
                  activeResource === i &&
                  resource.video_type !== 'YouTube'
                "
                xmlns="http://www.w3.org/2000/svg"
                :class="[
                  activeResource === i ? 'h-16 w-16' : 'h-8 w-8',
                  'opacity-80 transition-all z-30 duration-300 ease-in-out',
                ]"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fill-rule="evenodd"
                  d="M10 18a8 8 0 100-16 8 8 0 000 16zM9.555 7.168A1 1 0 008 8v4a1 1 0 001.555.832l3-2a1 1 0 000-1.664l-3-2z"
                  clip-rule="evenodd"
                />
              </svg>

              <svg
                v-if="resource.type === 2 && activeResource === i"
                xmlns="http://www.w3.org/2000/svg"
                :class="[
                  activeResource === i ? 'h-16 w-16' : 'h-8 w-8',
                  'opacity-80 transition-all z-30 duration-300 ease-in-out',
                ]"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fill-rule="evenodd"
                  d="M3 4a1 1 0 011-1h4a1 1 0 010 2H6.414l2.293 2.293a1 1 0 01-1.414 1.414L5 6.414V8a1 1 0 01-2 0V4zm9 1a1 1 0 110-2h4a1 1 0 011 1v4a1 1 0 11-2 0V6.414l-2.293 2.293a1 1 0 11-1.414-1.414L13.586 5H12zm-9 7a1 1 0 112 0v1.586l2.293-2.293a1 1 0 011.414 1.414L6.414 15H8a1 1 0 110 2H4a1 1 0 01-1-1v-4zm13-1a1 1 0 011 1v4a1 1 0 01-1 1h-4a1 1 0 110-2h1.586l-2.293-2.293a1 1 0 011.414-1.414L15 13.586V12a1 1 0 011-1z"
                  clip-rule="evenodd"
                />
              </svg>

              <svg
                v-if="resource.type === 1 && activeResource === i"
                xmlns="http://www.w3.org/2000/svg"
                :class="[
                  activeResource === i ? 'h-16 w-16 mt-32' : 'h-8 w-8',
                  'opacity-80 transition-all z-30 duration-300 ease-in-out',
                ]"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fill-rule="evenodd"
                  d="M3 17a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm3.293-7.707a1 1 0 011.414 0L9 10.586V3a1 1 0 112 0v7.586l1.293-1.293a1 1 0 111.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z"
                  clip-rule="evenodd"
                />
              </svg>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Arrows -->
    <div
      :class="[showMediaModal ? 'opacity-0' : '']"
      class="h-32 xl:h-2/12 w-full flex justify-between items-center relative z-40"
    >
      <div class="flex justify-between xl:absolute xl:bottom-0 w-full">
        <div
          class="pb-4 pl-8 hover:text-expo_red"
          :class="[
            activeResource > 0 ? '' : 'opacity-0',
            'transition-all duration-300 ease-in-out',
          ]"
          @click="scrollLeft()"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-6 w-6 featured-post-arrow cursor-pointer"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M7 16l-4-4m0 0l4-4m-4 4h18"
            />
          </svg>
        </div>
        <div
          class="pb-4 pr-8 hover:text-expo_red"
          :class="[
            activeResource >= posts.length - 1 ? 'opacity-0' : '',
            'transition-all duration-300 ease-in-out',
          ]"
          @click="scrollRight()"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-6 w-6 featured-post-arrow cursor-pointer"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M17 8l4 4m0 0l-4 4m4-4H3"
            />
          </svg>
        </div>
      </div>
    </div>
    <!-- /Arrows -->

    <!-- Media Modal -->
    <div
      v-if="settings.featured_resources.length > 0"
      v-show="showMediaModal"
      id="showMediaModal"
      class="fixed z-50 inset-0 overflow-y-auto"
      aria-labelledby="modal-title"
      role="dialog"
      aria-modal="true"
    >
      <div
        class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0"
      >
        <div
          class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
          aria-hidden="true"
        ></div>
        <!-- This element is to trick the browser into centering the modal contents. -->
        <span
          class="hidden sm:inline-block sm:align-middle sm:h-screen"
          aria-hidden="true"
          >&#8203;</span
        >
        <!-- Modal panel, show/hide based on modal state. -->
        <div
          :style="[
            modalLoaded ? { height: modalHeight + 'px' } : {},
            settings.featured_resources[activeResource].type === 2
              ? { height: 'calc(100vh - 10rem)' }
              : {},
          ]"
          :class="modalLoaded ? '' : 'p-8 w-52 h-52'"
          class="bg-cover inline-block align-bottom bg-white border-8 border-white rounded-4xl p-6 text-left shadow transform transition-all duration-300 ease-in-out sm:my-8 sm:align-middle sm:max-w-4xl sm:max-h-lg sm:w-full sm:p-16 relative"
        >
          <div
            :style="[
              settings.featured_resources[activeResource].type === 2
                ? {
                    backgroundImage:
                      'url(' +
                      settings.featured_resources[activeResource].file +
                      ')',
                  }
                : {},
            ]"
            class="flex flex-col bg-black absolute bg-center inset-0 w-full h-full rounded-4xl overflow-hidden z-10 bg-no-repeat"
            :class="[
              settings.featured_resources[activeResource].type !== 1
                ? 'bg-contain'
                : 'bg:cover',
            ]"
          >
            <div
              v-if="
                settings.featured_resources[activeResource].type === 3 &&
                settings.featured_resources[activeResource].video_type ===
                  'YouTube' &&
                showMediaModal
              "
              id="YouTube"
              class="z-30 aspect-w-16 aspect-h-9 rounded-4xl"
            >
              <div
                class="absolute top-0 left-0 h-52 p-16 flex items-center justify-center"
              >
                <lottie :options="loadingAnimationOptions" />
              </div>
              <iframe
                ref="resourceVideoPreview"
                type="iframe"
                class="rounded z-30"
                :src="
                  youtube +
                  settings.featured_resources[activeResource].video_code
                "
                frameborder="0"
                controls="0"
                modestbranding="1"
                showinfo="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
                @load="modalResize"
              ></iframe>
            </div>
            <div
              v-if="
                settings.featured_resources[activeResource].type === 3 &&
                settings.featured_resources[activeResource].video_type ===
                  'Vimeo' &&
                showMediaModal
              "
              id="Vimeo"
              class="z-30 aspect-w-16 aspect-h-9 rounded-4xl"
            >
              <div
                class="absolute top-0 left-0 h-52 p-16 flex items-center justify-center"
              >
                <lottie :options="loadingAnimationOptions" />
              </div>
              <iframe
                ref="resourceVideoPreview"
                type="iframe"
                class=""
                :src="
                  vimeo + settings.featured_resources[activeResource].video_code
                "
                controls="0"
                pip="0"
                title="0"
                frameborder="0"
                allow="autoplay; fullscreen; picture-in-picture"
                allowfullscreen
                @load="modalResize"
              ></iframe>
            </div>
          </div>
          <div class="flex flex-col space-y-4">
            <button
              type="button"
              class="absolute z-40 right-16 top-12 transform hover:rotate-180 transition-all duration-300 text-white hover:text-expo_red"
              @click="closeModal"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { EventBus } from '../../../js/plugins/event-bus.js'
import { shared } from '../../../js/mixins/shared.js'
import { mapGetters } from 'vuex'
import * as loadingAnimation from '../../../shared/components/loading.json'

export default {
  mixins: { shared },

  data() {
    return {
      activeResource: 0,
      postClass:
        'bg-gray-50 flex justify-center items-center border-white mx-4 border-8 bg-center cursor-pointer rounded-4xl transition-all duration-500 ease-in-out filter hover:shadow-xl',
      activeClass: 'h-72 w-72',
      sliderWidth: '',
      menuPosition: '0rem',
      postChanging: false,
      showMediaModal: false,
      youtube: 'https://www.youtube.com/embed/',
      vimeo: 'https://player.vimeo.com/video/',

      posts: [],

      exposAttending: [
        'Auckland',
        'Wellington',
        'Christchurch',
        'Hamilton',
        'Dunedin',
      ],

      resources: false,
      modalHeight: null,
      modalLoaded: false,
      loadingAnimationOptions: { animationData: loadingAnimation.default },
    }
  },

  computed: {
    ...mapGetters({
      settings: 'shared/getSettings',
    }),
  },

  watch: {
    showMediaModal: {
      handler: function (val) {
        EventBus.$emit('modal_state_changing', val)
      },

      deep: true,
    },

    settings: {
      handler: function (settings) {
        this.$set(this, 'posts', settings.featured_resources)
      },

      deep: true,
    },
  },

  mounted() {
    this.$set(this, 'posts', this.settings.featured_resources)
    this.checkWidth()
  },

  methods: {
    resourceCTA(i) {
      if (this.activeResource === i) {
        if (this.settings.featured_resources[this.activeResource].type === 1) {
          let id = this.settings.featured_resources[this.activeResource].id
          let el_id = 'fileRef-' + id
          if (document.getElementById(el_id)) {
            document.getElementById(el_id).click()
          }
        } else {
          this.$set(this, 'showMediaModal', true)
        }
      } else {
        this.$set(this, 'postChanging', true)
        this.$set(this, 'activeResource', i)
        EventBus.$emit('NonManagerRouteClicked')
        this.changeMenuPosition()
        setTimeout(() => {
          this.$set(this, 'postChanging', false)
        }, 400)
      }
    },

    viewPost(id) {
      this.$router.push({ path: `/post/${id}` })
      EventBus.$emit('NonManagerRouteClicked')
    },

    checkWidth() {
      //post count +1 for see all * post width + featured consideration + margin consideration
      let calcWidth = (this.posts.length + 1) * 12 + 6 + 2
      this.$set(this, 'sliderWidth', calcWidth + 'rem')
    },

    changeMenuPosition() {
      let right = this.activeResource * 13.7
      this.$set(this, 'menuPosition', right + 'rem')
    },

    scrollLeft() {
      if (this.activeResource > 0) {
        this.$set(this, 'postChanging', true)
        this.$set(this, 'activeResource', this.activeResource - 1)
        this.changeMenuPosition()
        setTimeout(() => {
          this.$set(this, 'postChanging', false)
        }, 400)
      }
    },

    scrollRight() {
      if (this.activeResource < this.posts.length - 1) {
        this.$set(this, 'postChanging', true)
        this.$set(this, 'activeResource', this.activeResource + 1)
        this.changeMenuPosition()
        setTimeout(() => {
          this.$set(this, 'postChanging', false)
        }, 400)
      }
    },

    showContactModal() {
      EventBus.$emit('showModal', 'contact')
    },

    modalResize() {
      if (this.settings.featured_resources[this.activeResource].type === 3) {
        let iframe = false

        if (
          this.settings.featured_resources[this.activeResource].video_type ===
          'Vimeo'
        ) {
          iframe = document.getElementById('Vimeo')
        } else {
          iframe = document.getElementById('YouTube')
        }

        this.$set(this, 'modalLoaded', true)
        this.$set(this, 'modalHeight', iframe.scrollHeight)
      } else {
        this.$set(this, 'modalHeight', 'calc(100vh - 10rem)')
        this.$set(this, 'modalLoaded', true)
      }
    },

    closeModal() {
      this.$set(this, 'showMediaModal', false)
      this.$set(this, 'modalLoaded', false)
    },
  },
}
</script>

<style scoped>
.info_wrapper::before {
  content: '';
  background: #fff;
  height: 1px;
  width: 1000px;
  max-width: 75%;
  position: absolute;
  top: 3.5rem;
  left: 0;
}

.expos-attending::before {
  content: '';
  background: #fff;
  height: 1px;
  width: 1000px;
  max-width: 75%;
  position: absolute;
  top: 0;
  right: 0;
}

.expo-title::after {
  background: #fff;
  position: absolute;
  content: '';
  right: -9px;
  top: 50%;
  transform: translateY(-50%);
  height: 2px;
  width: 2px;
  border-radius: 50%;
}

.expo-title:last-child::after {
  opacity: 0;
}

.post-image-node-container {
  width: calc(100% + 4rem);
}

.post-image-node-wrapper {
  width: fit-content;
}

@media screen and (max-width: 1024px) {
  .post-image-node-container {
    height: 20rem;
  }
}

.active-post::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1;
  height: 5rem;
  background: rgb(0, 0, 0);
  background: linear-gradient(
    180deg,
    rgba(0, 0, 0, 0.804359243697479) 0%,
    rgba(0, 0, 0, 0.5942752100840336) 6%,
    rgba(0, 0, 0, 0) 60%
  );
}
</style>
